import type { ComponentProps } from 'react'
import { Skeleton } from '@cocoonspace/ui/components/skeleton'
import { cn } from '@cocoonspace/ui/lib/utils'
import { TwicImg } from '@twicpics/components/react'

import type { EventItem } from '../my-events/use-all-events.hook'

export const EventCardSpacePreview = ({
	event,
	...props
}: {
	event: EventItem
	onClick?: () => void
} & ComponentProps<'div'>) => (
	<div
		{...props}
		className={cn(props.className, {
			'cursor-pointer': !!props.onClick,
		})}
	>
		<div className='relative mb-2 h-[156px] overflow-hidden rounded bg-slate-200/30'>
			{event.location?.images?.length && (
				<TwicImg
					alt={event.location?.name}
					focus='50px100p'
					ratio='16/9'
					src={`spaces/${event.location?.images[0].id}`}
				/>
			)}
		</div>

		<div className='truncate font-bold'>{event.location.name}</div>
	</div>
)

EventCardSpacePreview.skeleton = () => (
	<div>
		<Skeleton className='mb-2 h-[156px] w-full' />
		<Skeleton className='h-[16px] w-full' />
	</div>
)
